import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { ToastProvider } from '@/components/ToastProvider';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <ToastProvider>
      <div className="min-h-full">
        <Outlet />
      </div>
    </ToastProvider>
  );
}
